import type { ArtifactEventPayload } from '@sigora/domain';

import type { SigoraUIMessage } from './events.ts';

/**
 * The artifact parts the conversation has streamed, in order, for one study.
 *
 * They are read out of the messages rather than accumulated in a side channel because the chat
 * state is already doing the reconciliation: a part with an id it has seen replaces the earlier
 * one in place, so what is left in the transcript is one part per artifact holding its latest
 * streamed state. Duplicating that into a reducer here would mean two copies that can disagree.
 *
 * Filtered by study, because a streamed part names the study it was written to and the
 * sidebar is showing one of them.
 */
export const collectArtifactParts = (
  messages: readonly SigoraUIMessage[],
  studyId: string,
): ArtifactEventPayload[] =>
  messages.flatMap((message) =>
    message.parts.flatMap((part) =>
      part.type === 'data-artifact' && part.data.study_id === studyId ? [part.data] : [],
    ),
  );
